module.exports = __webpack_public_path__ + "img/resend-6.bcaee022.png";